// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RqPHDiFv7eEX7qJDLx2x{align-items:center;gap:4px;display:flex}.vttrfat8AkqbI_VeX26b{gap:4px;width:32px;display:flex}.D38i3i7bkior3PZnIONk{opacity:.5}.N6ZVASPXEcwwqyAlVurK{display:flex}.xtsZoK_yRoyTbc4oqS_r{margin-left:-12px}.xtsZoK_yRoyTbc4oqS_r:first-child{margin-left:0}.UAquOVCt8Ab7z4KwXaq_{flex-direction:column;gap:4px;max-width:250px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberCell": `RqPHDiFv7eEX7qJDLx2x`,
	"avatarWrapper": `vttrfat8AkqbI_VeX26b`,
	"avatarWrapperDisabled": `D38i3i7bkior3PZnIONk`,
	"ownerCell": `N6ZVASPXEcwwqyAlVurK`,
	"avatarOverlap": `xtsZoK_yRoyTbc4oqS_r`,
	"cellWrapper": `UAquOVCt8Ab7z4KwXaq_`
};
export default ___CSS_LOADER_EXPORT___;
